import Scroll from './modules/scroll'
import LanguagePicker from './modules/language-picker'
import SiteHeader from './modules/site-header'
import Appear from './modules/appear'
import CountUp from './modules/count-up'
import SiteFooter from './modules/site-footer'
import Page from './modules/page'

const modules = [Scroll, LanguagePicker, SiteHeader, Appear, CountUp, SiteFooter]
modules.forEach(module => Page.register(module))

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => Page.init(), { once: true })
} else {
  Page.init()
}

window.addEventListener('pagehide', () => Page.destroy())
window.addEventListener('pageshow', event => {
  if (event.persisted) Page.init()
})
